import camelCaseKeys from "camelcase-keys";
import { CustomerTabSchema } from "./schema";
import type { CustomerTab } from "./schema";
import { z } from "zod";
import { authorizedGet, authorizedPost } from "../authorizedRequests";

export interface CustomerTabRequest {
  name?: string;
  uuid?: string;
  tableUuid?: string;
  createdAt?: string;
  pendingOrder?: {
    orderItems: {
      itemUuid: string;
      salesPriceUuid: string;
      multiplier: number;
      orderItemMods: {
        itemModUuid: string;
        itemModType: "mandatory" | "optional";
        salesPriceUuid: string;
      }[];
    }[];
  };
}
export const fetchCustomerTab = async (
  customerTab: CustomerTabRequest
): Promise<CustomerTab> => {
  const response = await authorizedGet({
    url: `/v1/customer_tabs/${customerTab.uuid}`,
  });
  const responseData = camelCaseKeys(response.body.customer_tab, {
    deep: true,
  });

  return CustomerTabSchema.parse(camelCaseKeys(responseData, { deep: true }));
};

const CheckoutResponseSchema = z.object({
  checkoutUrl: z.string(),
});

export const createCheckoutSession = async (customerTabUuid: string) => {
  const { body } = await authorizedPost({
    url: `/v1/customer_tabs/${customerTabUuid}/checkout_sessions`,
    body: {},
  });
  const { checkoutUrl } = CheckoutResponseSchema.parse(
    camelCaseKeys(body, { deep: true })
  );
  return checkoutUrl;
};
